import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IPointsOfferTrend } from '@/shared/model/points-offer-trend.model';

const baseApiUrl = 'api/points-offer-trends';
const baseSearchApiUrl = 'api/_search/points-offer-trends?query=';

export default class PointsOfferTrendService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IPointsOfferTrend> {
    return new Promise<IPointsOfferTrend>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IPointsOfferTrend): Promise<IPointsOfferTrend> {
    return new Promise<IPointsOfferTrend>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IPointsOfferTrend): Promise<IPointsOfferTrend> {
    return new Promise<IPointsOfferTrend>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
